import { useTranslation } from 'react-i18next';

import {
  MaritalStatusesEnum,
  DEFAULT_NAME_FIELD_REGEX
} from '@thinknet-gmbh/platform-common';

import {
  Form,
  PhoneNumberInput,
  PLATFORM_THEME_COLORS,
  SelectInput,
  TextInput,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import {
  ComponentWrapper,
  FieldsInfoWrapper,
} from '../questionnaire-form/questionnaire-form.styles';

const EmergencyContact = () => {
  const { t } = useTranslation('employee');

  return (
    <ComponentWrapper>
      <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
        {t('emergencyDetails.labels.headerTitle')}
      </Typography>
      <FieldsInfoWrapper>
        <Form.Item
          name={['emergencyContact', 'name']}
          label={t('emergencyDetails.labels.emergencyName')}
          rules={[
            {
              required: true,
              message: t('emergencyDetails.validation.emergencyNameRequired'),
            },
            {
              pattern: DEFAULT_NAME_FIELD_REGEX,
              message: t('common:validation.error.incorrectFormat'),
            },
          ]}
        >
          <TextInput maxLength={50} placeholder={t('emergencyDetails.placeholders.emergencyName')} />
        </Form.Item>
        <Form.Item
          name={['emergencyContact', 'phoneNumber']}
          label={t('emergencyDetails.labels.emergencyPhoneNumber')}
          rules={[
            {
              required: true,
              message: t('emergencyDetails.validation.emergencyPhoneNumberRequired'),
            },
          ]}
        >
          <PhoneNumberInput placeholder="+49 176 384 15749" />
        </Form.Item>
        <Form.Item
          name={['emergencyContact', 'relationship']}
          label={t('emergencyDetails.labels.emergencyRelationship')}
          rules={[
            {
              required: true,
              message: t('emergencyDetails.validation.emergencyContactRequired'),
            },
          ]}
        >
          <TextInput maxLength={50} placeholder={t('emergencyDetails.placeholders.emergencyRelationship')} />
        </Form.Item>
        <Form.Item
          name={['emergencyContact', 'maritalStatus']}
          label={t('emergencyDetails.labels.maritalStatus')}
        >
          <SelectInput placeholder={t('emergencyDetails.labels.married')}>
            {Object.keys(MaritalStatusesEnum).map(status => (
              <SelectInput.Option key={status} value={status}>
                {t(`emergencyDetails.labels.${status.toLowerCase()}`)}
              </SelectInput.Option>
            ))}
          </SelectInput>
        </Form.Item>
        <Form.Item
          name={['emergencyContact', 'childAllowance']}
          label={t('emergencyDetails.labels.childAllowance')}
        >
          <TextInput maxLength={50} placeholder={t('emergencyDetails.labels.noChildren')} />
        </Form.Item>
      </FieldsInfoWrapper>
    </ComponentWrapper>
  );
};

export default EmergencyContact;
